var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "three-columns container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.columns, function (column) {
        return _c(
          "div",
          { staticClass: "column small-12 medium-4" },
          [
            _c("single-column", {
              attrs: {
                image: column.image,
                title: column.title,
                link: column.link,
              },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }